import { TextAreaField, TextField } from "./SettingsFields";

function SeoSettingsForm({ settings, onChange }) {
  return (
    <section className="admin-settings-section">
      <TextField label="About meta title" name="about_meta_title" value={settings.about_meta_title} onChange={onChange} />
      <TextAreaField label="About meta description" name="about_meta_description" value={settings.about_meta_description} onChange={onChange} />
      <TextField label="Contact meta title" name="contact_meta_title" value={settings.contact_meta_title} onChange={onChange} />
      <TextAreaField label="Contact meta description" name="contact_meta_description" value={settings.contact_meta_description} onChange={onChange} />
    </section>
  );
}

export default SeoSettingsForm;